import { createSelector } from 'reselect';

import {
    selectFilteredTripsWithNearby,
    selectTripMetadata,
} from './trips';

function _countNearbyTrips(trips, tripMetadata) {
    return {
        num: trips.filter((trip) => {
            const {
                exactOriginMatch,
                exactDestMatch,
            } = tripMetadata[trip.tripId] || {};

            return !exactOriginMatch || !exactDestMatch;
        }).length,
    };
}

const selectAllowNearbyTripData = createSelector(
    selectFilteredTripsWithNearby,
    selectTripMetadata,
    _countNearbyTrips,
);

export {
    selectAllowNearbyTripData,
};
